import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core';
import { Plane2Model } from '../../../model';
import { EntityDragEvent } from '../../mouse/mouse-entity.service';
import { ScaleDirection, Ng3EdgeResizeEvent } from '../resize-helper';
import { CanvasService } from '../../../components/canvas.service';

@Component({
  selector: 'ng3-resize-plane-edge',
  templateUrl: './resize-plane-edge.component.html',
  styleUrls: ['./resize-plane-edge.component.css'],
})
export class ResizePlaneEdgeComponent implements OnInit, OnDestroy {
  @Input() model: Plane2Model | undefined;
  @Input() direction: ScaleDirection = 'top';
  @Input() z = 1;
  @Output() resize = new EventEmitter<Ng3EdgeResizeEvent>();
  constructor(private canvas: CanvasService) {}

  ngOnInit() {
    if (this.model === undefined) {
      throw Error('Model is not provided');
    }
  }
  ngOnDestroy() {}
  setStyle(isHover: boolean) {
    this.canvas.domElement.style.cursor = isHover ? this.cursorStyle() : 'auto';
  }
  private cursorStyle() {
    switch (this.direction) {
      case 'top':
      case 'bottom':
        return 'ns-resize';
      case 'left':
      case 'right':
        return 'ew-resize';
    }
  }
  onDrag(e: EntityDragEvent, direction: ScaleDirection) {
    this.resize.emit({
      type: 'edge',
      direction: this.direction,
      to:
        this.direction === 'left' || this.direction === 'right'
          ? e.relativeCenter.x
          : e.relativeCenter.y,
    });
  }
}
